import { Transforms } from 'slate';
import { createImageNode, createParagraphNode } from './utils';

export const insertImage = (editor, url, alt) => {
    if (!url) {
        return;
    }

    Transforms.insertNodes(editor, [createImageNode(alt, url), createParagraphNode()]);
};

export const withImages = (editor) => {
    const { isVoid } = editor;

    editor.isVoid = (element) => (element.type === 'image' ? true : isVoid(element));

    return editor;
};
